import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


import { Alert, Button, Checkbox, FileUpload, Form, FormField, List, SpaceBetween, Textarea } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { addDays, format } from 'date-fns';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import SelectEquipment from '../../../../../components/selects/selectEquipment';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemBooking } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, fileToBase64, getCookie, getUrlVersion, isMobileDevice, setData, setLoading } from '../../../../commons/functions';


type ItemFile = {
    file: File;
    fileName?: string;

}

type ItemNote = {
    idMaintenance: number;
    idEquipment: number;
    note: string;
    isOutOfFlight: number;
    dateSubmited?: string,
    jsonImages: any[];
};

export const CMANotesAddPage = () => {
    //const storeAdmin = useStoreAdmin();
    const { menu } = useGlobalState();

    useGlobalState();

    const { navigate } = useRouter();





    const [files, setFiles] = React.useState<File[]>([]);
    const [bookings, setBookings] = React.useState<ItemBooking[]>([]);


    const [note, setNote] = useState<ItemNote>();
    const handleUpdateSubmited = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/mants/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                timeout: 60000,
                body: JSON.stringify(note),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);

        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleCheckBookings = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/bookings/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idEquipment: note?.idEquipment || 0,
                    startDate: format(new Date(), "dd-MM-yyyy"),
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {
                if (dataWeb.bookings)
                    setBookings(dataWeb.bookings)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    useEffect(() => {
        setNote({ idMaintenance: 0, idEquipment: 0, isOutOfFlight: 0, note: '', jsonImages: [] });
    }, []);



    const handleFileChange = async (files: File[]) => {
        if (!note) return;
        try {
            // Use Promise.all to concurrently convert all files to Base64
            const base64Results = await Promise.all(files.map(fileToBase64));

            // Map the results back to an array of objects that include the Base64 data hjjhg 
            const attachmentsWithBase64 = base64Results.map(result => ({
                idMaintenance: note.idMaintenance,
                fileName: result.file.name,
                fileContent: result.base64,
                fileSize: result.file.size,
            }));
            setNote((prev: ItemNote | undefined) => {
                if (!prev) return prev;
                return {
                    ...prev,
                    // Use the spread operator on the entire new array to append all new files
                    jsonImages: [...(prev?.jsonImages || []), ...attachmentsWithBase64]
                };
            });
        } catch (error) {
            console.error('Error reading files:', error);
            // Handle error state if necessary
        }
    };

    useEffect(() => {
        if (note) {
            if (note.isOutOfFlight === 0) {
                setBookings([]);

            } else {
                handleCheckBookings();
            }
        }

    }, [note?.isOutOfFlight, note?.dateSubmited, note?.idEquipment]);
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const isDisabled = useMemo(() => {
        if (note && note.idEquipment > 0 && note.note.trim() !== '') {
            return false;
        }
        return true;

    }, [note?.idEquipment, note?.note]);

    const handleTakePhoto = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // Handle photos taken from camera input
    const handleCameraChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = e.target.files ? Array.from(e.target.files) : [];
        if (selectedFiles.length > 0) {
            setFiles(prev => [...prev, ...selectedFiles].slice(0, 3)); // limit to 3
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h2" actions={<Favorites />}>Agregar nota</Header>

                    <SpaceBetween size="xs" direction='horizontal'>
                        <div style={{ width: 200 }}>
                            <FormField label="Material">
                                <SelectEquipment
                                    isMant={1}
                                    onConfirm={(equipment) => {
                                        if (equipment && note) {
                                            setNote({ ...note, idEquipment: equipment.idEquipment });
                                        }
                                    }} value={note?.idEquipment || 0} />
                            </FormField>
                        </div>{note && note?.idEquipment > 0 && (
                            <FormField label="Fecha">
                                <DPModal date={note.dateSubmited}
                                    end={new Date()}
                                    start={(addDays(new Date(), -14))}
                                    onConfirm={(date) => {
                                        setNote({ ...note, dateSubmited: date });
                                    }} />
                            </FormField>
                        )}
                    </SpaceBetween>
                    {note && note.idEquipment > 0 && (
                        <Form
                            actions={
                                <Button variant="primary" disabled={isDisabled} onClick={() => {
                                    handleUpdateSubmited();
                                }}
                                >Enviar nota</Button>
                            }
                        >

                            <SpaceBetween size="s" direction='vertical'>

                                <FormField label="Nota">
                                    <Textarea value={note.note} onChange={(e) => setNote({ ...note, note: e.detail.value })} />
                                </FormField>
                                <Checkbox checked={note.isOutOfFlight === 1} onChange={(e) => setNote({ ...note, isOutOfFlight: e.detail.checked ? 1 : 0 })}>Fuera de vuelo</Checkbox>
                                {bookings && bookings.length > 0 && (
                                    <Alert type="warning" header={"Las siguentes reservas serán notificadas por fuera de vuelo"}>
                                        <List items={bookings.map((booking) => ({
                                            id: booking.idBooking.toString(),
                                            content: `${booking.dateStart} ${booking.displayName}`,
                                        }))}
                                            renderItem={item => item}
                                        />

                                    </Alert>
                                )}

                                <FileUpload
                                    onChange={({ detail }) => {
                                        const newFiles = detail.value.slice(0, 3);
                                        setFiles(newFiles);
                                        handleFileChange(newFiles);
                                    }}
                                    accept="image/*"
                                    value={files}
                                    i18nStrings={{
                                        uploadButtonText: e =>
                                            "Seleccionar imagen",
                                        dropzoneText: e =>
                                            "Arrastre archivo para cargar",
                                        removeFileAriaLabel: e =>
                                            `Eliminar archivo ${e + 1}`,
                                        limitShowFewer: "Show fewer files",
                                        limitShowMore: "Show more files",
                                        errorIconAriaLabel: "Error",
                                        warningIconAriaLabel: "Warning"
                                    }}
                                    multiple
                                    showFileSize
                                    showFileThumbnail
                                    fileTokenAlignment="horizontal"
                                    tokenLimit={3}
                                />

                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept="image/*"
                                    capture="environment" // or "user" for front camera
                                    style={{ display: "none" }}
                                    onChange={handleCameraChange}
                                />
                                {isMobileDevice() && (
                                    <Button onClick={handleTakePhoto}>
                                        Tomar foto
                                    </Button>
                                )}

                            </SpaceBetween>
                        </Form>

                    )}
                </SpaceBetween>
            }
        />
    );
};
